import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import LinearBarPercent from '../../styles/LinearBarPercent';

const SelectionDetailGrid = (props) => {
  // const bgcolor = props.color ? props.color : null;

  const flexBoxContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: 1,
  };

  const renderCell = (label, value) => (
    <Stack direction="row" spacing={1}>
      <Typography variant="body2">{label}:</Typography>
      <Typography variant="body2" sx={{ fontWeight: '600' }}>
        {value}
      </Typography>
    </Stack>
  );

  // const linearBarPercentStyles = {
  //   margin: '0.5em',
  //   '& .MuiLinearProgress-bar1Determinate': {
  //     backgroundColor: bgcolor,
  //   },
  // };

  return (
    <Grid container>
      <Grid item xs={8}>
        <Stack direction="row" spacing={1} sx={flexBoxContainer}>
          {renderCell(props.label1, props.value1)}
          {/* {renderCell(props.label2, `${props.value2}%`)} */}
        </Stack>
      </Grid>
      {/* <Grid item xs={4}>
        <LinearBarPercent
          variant="determinate"
          value={Number(props.value2)}
          sx={linearBarPercentStyles}
        />
      </Grid> */}
    </Grid>
  );
};

export default SelectionDetailGrid;
